module.exports = __webpack_public_path__ + "static/img/applicationBanner.bd67eb0f.png";